import Image from "next/image";
import type { Product } from "~/types";
import { Box } from "../Box/Box";
import { Button } from "../Button/Button";
import { HotDealCard } from "../HotDealCard/HotDealCard";
import { Stack } from "../Stack/Stack";
import { Text } from "../Text/Text";
import { VoucherCodeDialog } from "./VoucherCodeDialog/VoucherCodeDialog";

export interface VoucherCodeDealProps {
  plu?: string | null;
  title: string;
  description?: string | null;
  disabled?: boolean;
  inCart: boolean;
  onClose: () => void;
  onContinue: () => void;
  busy?: boolean;
  // A DealAsVoucher is auto-added, so the button always continues to the cart.
  isVoucher?: boolean;
}

export function VoucherCodeDeal({
  plu,
  title,
  description,
  disabled = false,
  inCart,
  onClose,
  onContinue,
  busy,
  isVoucher = false,
}: VoucherCodeDealProps) {
  // Only an in-cart, non-voucher deal closes the modal; everything else continues.
  const onClick = !isVoucher && inCart ? onClose : onContinue;
  const message = voucherDealMessage(isVoucher, inCart);
  const messageColor = isVoucher || inCart ? "jets-red" : "jets-black";

  return (
    <VoucherCodeDialog>
      <Stack space={"5"}>
        <Text align={"center"} font="accent" weight="strong" size="large">
          {plu}
        </Text>

        <HotDealCard
          title={title}
          description={description}
          disabled={disabled}
          onSelect={onClick}
        />
        <Text color={messageColor} size="large" weight="strong">
          {message}
        </Text>

        <Button primary onClick={onClick} disabled={busy}>
          Continue
        </Button>
      </Stack>
    </VoucherCodeDialog>
  );
}

function voucherDealMessage(isVoucher: boolean, inCart: boolean): string {
  if (isVoucher) {
    return "Coupon added to your cart, discount will be applied at check out";
  }
  if (inCart) {
    return "This item is already in your cart, discount will be applied at check out";
  }
  return "Add this item to your cart now, discount will be applied at check out";
}

export function DaveDeal({
  product,
  onClick,
}: {
  product: Product;
  onClick: () => void;
}) {
  return (
    <VoucherCodeDialog>
      <Stack space={"5"}>
        <Text align={"center"} font="accent" weight="strong" size="large">
          {product.title}
        </Text>

        {product.imageUrl && (
          <Box display={"flex"} justifyContent="center">
            <Image
              src={product.imageUrl}
              alt={product.title}
              width={271}
              height={317}
            />
          </Box>
        )}

        <Text color="jets-black" size="large" weight="strong" align={"center"}>
          Site made with love by Dave, Ari, Den, Dom, Stevo, Alex, Jarrod, Jett
          (really) & Jacob.
        </Text>

        <Button primary onClick={onClick}>
          Impressed
        </Button>
      </Stack>
    </VoucherCodeDialog>
  );
}
